function HeaderDropdownItem({ children }) {
  return <div>{children}</div>
}

export default HeaderDropdownItem
